export enum CoverType {
  MAIN = 'MAIN',
  OPTIONAL = 'OPTIONAL',
  DISCOUNT = 'DISCOUNT',
}

export interface PriceOption {
  coverGroup: string
  coverType: CoverType
  premium: number
  totalPremium: number
  taxAmount: number
  active: boolean | undefined
  endAt: string | null
  insurer: string
  covers?: string[]
}

export type AdditionalPriceOption = Pick<
  PriceOption,
  'active' | 'coverGroup' | 'coverType' | 'premium'
> & {
  tag: string
}
